export const DEFAULT_COPY = {
  title: 'Let’s make sure you’re eligible',
  copy: 'Please answer the following questions to check if you are eligible for any of our assistance programs',
  message: {
    eligible:
      '**You are eligible to apply!**\n\nSelect the button below to create your account. Please note that this is not a guarantee you will receive assistance.',
    ineligible:
      "**You're ineligible to apply for assistance.**\n\nBased on your answers, you probably will not qualify for {PARTNER_NAME}'s programs. If you think this assessment is wrong, review your answers and re-check your eligibility. If you have any questions, contact [{PARTNER_EMAIL}]({PARTNER_EMAIL})",
  },
};

export const HOUSEHOLD_SIZE_ITEMS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8+', value: 8 },
];

export const AMI_FIELDS = ['location', 'householdSize', 'isIncomeAboveLimit'];
